import { create } from "zustand";

import { FilterChipKind, SearchResult } from "@app/analytics/types";

interface SearchMeetingsStore {
  allSearchResults: SearchResult[];
  setAllSearchResults: (results: SearchResult[]) => void;
  setSearchResults: (results: SearchResult[]) => void;
  searchResults: SearchResult[];
  setSearchFilterChipKinds: (
    searchFilterChipKinds: Set<FilterChipKind>
  ) => void;
  searchFilterChipKinds: Set<FilterChipKind>;
  resetSearchFilterChipKinds: () => void;
  setSearchQuery: (query: string) => void;
  searchQuery: string;
  isSearching: boolean;
  setIsSearching: (isSearching: boolean) => void;
}

const ALL_FILTER_CHIP_KINDS = new Set<FilterChipKind>(["all"]);

const useSearchMeetingsStore = create<SearchMeetingsStore>((set) => ({
  allSearchResults: [],
  setAllSearchResults: (results) => set({ allSearchResults: results }),
  setSearchResults: (searchResults) => set({ searchResults }),
  searchResults: [],
  setSearchFilterChipKinds: (searchFilterChipKinds) =>
    set({ searchFilterChipKinds }),
  searchFilterChipKinds: ALL_FILTER_CHIP_KINDS,
  resetSearchFilterChipKinds: () =>
    set({ searchFilterChipKinds: ALL_FILTER_CHIP_KINDS }),
  setSearchQuery: (query) => set({ searchQuery: query }),
  searchQuery: "",
  isSearching: false,
  setIsSearching: (isSearching) => set({ isSearching }),
}));

export default useSearchMeetingsStore;
